export const EmptyShiftPendingReview = () => (
  <svg
    width="171"
    height="171"
    viewBox="0 0 171 171"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="85.5" cy="85.5" r="85.5" fill="#EBF4F5" />
    <g opacity="0.8">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.6351 44.7551C53.4533 44.7551 50.874 47.3344 50.874 50.5162V56.2773H45.113C38.7495 56.2773 33.5908 61.4359 33.5908 67.7994V125.41C33.5908 131.774 38.7495 136.932 45.113 136.932H114.246C120.609 136.932 125.768 131.774 125.768 125.41V67.7994C125.768 61.4359 120.609 56.2773 114.246 56.2773H108.485V50.5162C108.485 47.3344 105.905 44.7551 102.724 44.7551C99.5418 44.7551 96.9625 47.3344 96.9625 50.5162V56.2773H62.3961V50.5162C62.3961 47.3344 59.8168 44.7551 56.6351 44.7551ZM56.6351 77.2099C53.4533 77.2099 50.874 79.7892 50.874 82.971C50.874 86.1527 53.4533 88.7321 56.6351 88.7321H102.724C105.905 88.7321 108.485 86.1527 108.485 82.971C108.485 79.7892 105.905 77.2099 102.724 77.2099H56.6351Z"
        fill="#A4E0E0"
      />
    </g>
    <path
      d="M65.2781 51.2258V32.0222M103.685 51.2258V32.0222M61.731 76.0904H106.68M47.2795 122.05H121.684C126.987 122.05 131.286 117.752 131.286 112.449V51.2258C131.286 45.9229 126.987 41.624 121.684 41.624H47.2795C41.9766 41.624 37.6777 45.9229 37.6777 51.2258V112.449C37.6777 117.752 41.9766 122.05 47.2795 122.05Z"
      stroke="#0B8397"
      strokeWidth="8.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="124" cy="117" r="25" fill="#EBF4F5" stroke="#EBF4F5" strokeWidth="8" />
    <path
      d="M144 118.042C143.79 129.13 135.258 137.975 124.017 138C112.833 138.025 104.019 129.239 104 118.038C103.981 106.786 112.816 98.0168 123.941 98C135.214 97.9832 143.841 106.872 144 118.042Z"
      fill="#A4E0E0"
    />
    <path
      d="M131.844 113.515C132.863 112.495 134.516 112.495 135.535 113.515C136.555 114.534 136.555 116.187 135.535 117.207L124.649 128.093C123.63 129.112 121.978 129.112 120.958 128.093L115.515 122.649C114.495 121.63 114.495 119.978 115.515 118.958C116.534 117.938 118.187 117.938 119.207 118.958L122.804 122.555L131.844 113.515Z"
      fill="#EBF4F5"
      stroke="#EBF4F5"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M132.844 109.515C133.863 108.495 135.516 108.495 136.535 109.515C137.555 110.534 137.555 112.187 136.535 113.207L125.649 124.093C124.63 125.112 122.978 125.112 121.958 124.093L116.515 118.649C115.495 117.63 115.495 115.978 116.515 114.958C117.534 113.938 119.187 113.938 120.207 114.958L123.804 118.555L132.844 109.515Z"
      fill="#0B8397"
      stroke="#0B8397"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="126.5" cy="115.5" r="23.5" stroke="#0B8397" strokeWidth="8" />
  </svg>
);
